"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useRecordingSLI = require("./useRecordingSLI");
Object.keys(_useRecordingSLI).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useRecordingSLI[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useRecordingSLI[key];
    }
  });
});